/* AQ · Correctifs (2026-10-19), relevés des playruns.
   1. Champs entiers des tunnels (inputmode numeric, par exemple Nombre
      d'étages et Nombre d'unités). Ils acceptaient des lettres, envoyées
      telles quelles. Le champ ne garde plus que les chiffres, avant que le
      tunnel lise la valeur (écoute en phase de capture).
   2026-10-25, bogue trouvé par le harnais de parcours (entrepreneur) : le
      numéro de licence RBQ est aussi en inputmode numeric, mais son masque
      écrit 0000-0000-00 et sa validation exige les tirets. Au change, ce
      nettoyage retirait les tirets après le masque, et l'étape Licences
      refusait un numéro pourtant bien tapé. Un champ dont le pattern admet
      autre chose que des chiffres (tiret, espace) n'est plus nettoyé ici :
      son masque s'en charge. */
(function () {
  'use strict';
  function nettoyer(e) {
    var c = e.target;
    if (!c || c.tagName !== 'INPUT' || c.getAttribute('inputmode') !== 'numeric' || !c.closest('.aqp2')) return;
    var p = c.getAttribute('pattern') || '';
    if (p && /[^0-9\[\]{},]/.test(p)) return;
    var v = c.value.replace(/[^0-9]+/g, '');
    if (v !== c.value) c.value = v;
  }
  document.addEventListener('input', nettoyer, true);
  document.addEventListener('change', nettoyer, true);
})();
